/**
 * Contact Modal
 * Handles opening and closing of the floating contact modal
 */
export function contactModal() {
	const modal = document.getElementById('contact-modal')
	const openBtn = document.getElementById('open-contact-modal')
	const closeBtn = document.getElementById('close-contact-modal-btn')
	const overlay = document.getElementById('close-contact-modal')

	if (!modal || !openBtn) return

	const openModal = () => {
		modal.classList.add('active')
		document.body.style.overflow = 'hidden'
		// Focus first interactive element
		const firstFocusable = modal.querySelector('a, button')
		if (firstFocusable) firstFocusable.focus()
	}

	const closeModal = () => {
		modal.classList.remove('active')
		document.body.style.overflow = ''
		openBtn.focus()
	}

	// Open modal
	openBtn.addEventListener('click', openModal)

	// Close modal - button
	if (closeBtn) {
		closeBtn.addEventListener('click', closeModal)
	}

	// Close modal - overlay
	if (overlay) {
		overlay.addEventListener('click', closeModal)
	}

	// Close modal - ESC key
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && modal.classList.contains('active')) {
			closeModal()
		}
	})
}
